// https://github.com/TanStack/table/blob/v7/docs/src/pages/docs/api/useTable.md#column-options

/**
 * @typedef {object} ColumnDefinition
 * @property {string | Function} accessor - This string/function is used to build the data model for your column
 * @property {string} [id] - Unique ID for the column. Required if accessor is a function
 * @property {Array} [columns] -
 * @property {ReactNode} [Header]
 * @property {ReactNode} [Footer]
 * @property {ReactNode} [Cell]
 * @property {number} [width] - If using block layout, width is in pixels. If using flex layout, width is the flex-grow value
 * @property {number} [minWidth]
 * @property {number} [maxWidth]
 * @property {boolean} [canResize] - undocumented feature? of react-table. When canResize is false, width will be used for
 * fixed pixel values. When it is true, or unset (it defaults to true), width will be used for flex values.
 * @property {string} [className]
 */

/**
 * Create a function that can be used to build column definitions for react-table. This is useful for creating a
 * consistent column definition across multiple tables. The returned function can be passed in overrides to further
 * customize the column definition.
 * @param {ColumnDefinition} defaultColumnDefinition
 * @returns {function(ColumnDefinition=): ColumnDefinition}
 */
export const createColumnDefinitionBuilder = (defaultColumnDefinition) => (columnDefinitionOverrides) => {
  return {
    ...defaultColumnDefinition,
    ...(columnDefinitionOverrides || {}),
  };
};
